import type { State } from 'state';

const getForgotPasswordOrError = (state: State) => {
	return state.persisted.forgotPassword;
};

export const getResetUrl = (state: State): string | undefined => {
	const data = getForgotPasswordOrError(state);
	return data && 'forgotPassword' in data && data.forgotPassword
		? data.forgotPassword.resetUrl
		: undefined;
};
